import React from 'react';
import Icon from '@ant-design/icons';
import { ReactComponent as IconConstructorSvg }  from '../../assets/icons/icon_constructor_blue.svg';

const ConstructorIcon=(props)=>{
    return <Icon component={() => <IconConstructorSvg />} {...props}/>
}

export default ConstructorIcon;